<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-layout class="fill-viewport-height">
          <transition name="fade">
            <router-view />
          </transition>
        </v-layout>
      </v-content>
    </v-app>
  </div>
</template>


<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "sass/globals";

.header-grid{
  width: 100%;
  height: 50%;
  // background: black;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  color: white;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  font-size: 16pt;
  font-family: Poppins-Regular;
  // background: cyan;
}
img {
  max-width: 100%;
}
.fill-viewport-height {
  height: 100vh; //Antes estaba 100% pero no funcionaba en navegadores iOS
}

/********************  FONTS ********************/
/* Las fuentes se cargan acá porque se tiene acceso a los recursos que están en assets*/
.hamburguesa{
  color: #00569F;
  width: 50px;
  height: 50px;
  background:white;
  border-radius: 50%
 
}

.v-btn__content{
  color: #00569F;
}

@font-face {
  font-family: Poppins-Regular;
  src: url("./assets/fonts/Poppins-Regular.ttf");
}
@font-face {
  font-family: Poppins-SemiBold;
  src: url("./assets/fonts/Poppins-SemiBold.ttf");
}
@font-face {
  font-family: Poppins-Bold;
  src: url("./assets/fonts/Poppins-Bold.ttf");
}
@font-face {
  font-family: Poppins-BoldItalic;
  src: url("./assets/fonts/Poppins-BoldItalic.ttf");
}
@font-face {
  font-family: Poppins-Black;
  src: url("./assets/fonts/Poppins-Black.ttf");
}
@font-face {
  font-family: Poppins-Italic;
  src: url("./assets/fonts/Poppins-Italic.ttf");
}
@font-face {
  font-family: Poppins-Medium;
  src: url("./assets/fonts/Poppins-Medium.ttf");
}
@font-face {
  font-family: Poppins-MediumItalic;
  src: url("./assets/fonts/Poppins-MediumItalic.ttf");
}

/******** IMÁGENES RETROALIMENTACIÓN BIEN Y MAL PARA DRAG N DROP **************************/
.actividad-drap-n-drop {
  .mal,
  .bien {
    position: relative;
    color: black;
    &:after {
      content: "";
      top: -12px;
      right: -12px;
      position: absolute;
      width: 25px;
      height: 25px;
      background-size: contain;
      z-index: 1;
    }
  }
  .mal {
    background-color: lighten(red, 30) !important;
    &:after {
      content: "";
      background-image: url("./assets/imagenes_compartidas/Cerrar_Ventana.png");
    }
  }
  .bien {
    background-color: lighten($verde-cla, 20) !important;
    &:after {
      content: "";
      background-image: url("./assets/imagenes_compartidas/Cerrar_Ventana.png");
    }
  }
}
/************* IMÁGENES DE BIEN/VISTO EN GENERAL *********************/

.bot-check-vis, .bot-check-vis-cen, .feedback-mal, .feedback-mal-cen {
  position: relative;
}

.bot-check-vis:after, .feedback-mal:after {
  content: " ";
  background-image: url("./assets/imagenes_compartidas/check.svg");
  background-size: contain;
  position: absolute;
  width: 25px;
  height: 25px;
  top: -8px;
  right: -8px
}
.feedback-mal:after {
  background-image: url("./assets/imagenes_compartidas/Cerrar_Ventana.png");
}

.bot-check-vis-cen:after, .feedback-mal-cen:after {
  content: " ";
  background-image: url("./assets/imagenes_compartidas/check.svg");
  background-size: contain;
  position: absolute;
  width: 30px;
  height: 30px;
  top: -20px;
  right: 0;
  left: 0;
  margin: auto;
}
.feedback-mal-cen:after {
  background-image: url("./assets/imagenes_compartidas/Cerrar_Ventana.png");
}


.fade-enter-active, .fade-leave-active {
      transition: all 2s;
    position: absolute;
    max-height: 100%;
    min-height: 100%;
    max-width: calc(100% - 20px);
    min-width: calc(100% - 20px);
    overflow: hidden;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>

